import {backboneViewProperties} from "../../../decorators/backbone-properties";
import {AdvancedSearchFilterView} from "../../../search/views/advanced-search/advanced-search-filter";
import {AdvancedSearchFilterModel} from "../../../search/models/advanced-search-filter";

@backboneViewProperties({
    tagName: "div",
    childView : AdvancedSearchFilterView
})
export class AdvancedSearchFiltersView extends Marionette.CollectionView<AdvancedSearchFilterModel, AdvancedSearchFilterView> {
    constructor(options?: Marionette.CollectionViewOptions<AdvancedSearchFilterModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-filters.ts